import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import './Footer.css';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-section">
              <img 
                src="https://customer-assets.emergentagent.com/job_luxweddings/artifacts/z2ue59wi_Screenshot_2025-10-12_215301-removebg-preview.png" 
                alt="The Green Valley Logo"
                className="footer-logo"
              />
            </div>
            <p className="footer-text">
              The crown jewel of Shastripuram – West Agra's most cherished wedding and celebration venue.
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <Phone size={18} />
                <a href="tel:+918826372788" className="contact-link">+91 8826372788</a>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <a href="mailto:sales@greenvalleyagra.com" className="contact-link">sales@greenvalleyagra.com</a>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span className="contact-text">Shastripuram, West Agra - 282007</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/spaces" className="footer-link">Spaces & Ambience</Link>
              <Link to="/gallery" className="footer-link">Gallery</Link>
              <Link to="/events" className="footer-link">Events</Link>
              <Link to="/stay" className="footer-link">Stay</Link>
              <Link to="/weddings" className="footer-link">Weddings</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Services</h4>
            <nav className="footer-nav">
              <span className="footer-link">Wedding Planning</span>
              <span className="footer-link">Event Coordination</span>
              <span className="footer-link">Valet Parking</span>
              <span className="footer-link">Luxury Accommodation</span>
              <span className="footer-link">Custom Décor</span>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Location</h4>
            <p className="footer-text mb-16">
              100 Ft Road, Near Krishna Indraprastha Colony<br />
              Shastripuram, Agra – 282007
            </p>
            <a 
              href="https://www.google.com/maps/search/?api=1&query=The+Green+Valley+Shastripuram+Agra" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              View on Map
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} The Green Valley, Agra. All rights reserved.
          </p>
          <p className="footer-tagline">
            Where Every Celebration Finds Its Perfect Setting
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
